/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarImageDto } from '../model';
// @ts-ignore
import type { ImageUploadResponse } from '../model';
// @ts-ignore
import type { UploadImageRequest } from '../model';
/**
 * CarImageControllerApi - axios parameter creator
 * @export
 */
export const CarImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a car image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('deleteImage', 'imageId', imageId)
            const localVarPath = `/api/v1/car/image/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all images for a car (public endpoint)
         * @param {string} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarImages: async (carId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('getCarImages', 'carId', carId)
            const localVarPath = `/api/v1/public/car/{carId}/images`
                .replace(`{${"carId"}}`, encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get car image by ID (public endpoint)
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('getImage', 'imageId', imageId)
            const localVarPath = `/api/v1/public/car/image/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set an image as the primary image for a car
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryImage: async (imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('setPrimaryImage', 'imageId', imageId)
            const localVarPath = `/api/v1/car/image/{imageId}/primary`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an image for a car
         * @param {string} carId 
         * @param {boolean} [setPrimary] 
         * @param {UploadImageRequest} [uploadImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (carId: string, setPrimary?: boolean, uploadImageRequest?: UploadImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('uploadImage', 'carId', carId)
            const localVarPath = `/api/v1/car/{carId}/image`
                .replace(`{${"carId"}}`, encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)

            if (setPrimary !== undefined) {
                localVarQueryParameter['setPrimary'] = setPrimary;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarImageControllerApi - functional programming interface
 * @export
 */
export const CarImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a car image
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarImageControllerApi.deleteImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all images for a car (public endpoint)
         * @param {string} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarImages(carId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarImages(carId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarImageControllerApi.getCarImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get car image by ID (public endpoint)
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarImageControllerApi.getImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set an image as the primary image for a car
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryImage(imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryImage(imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarImageControllerApi.setPrimaryImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an image for a car
         * @param {string} carId 
         * @param {boolean} [setPrimary] 
         * @param {UploadImageRequest} [uploadImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(carId: string, setPrimary?: boolean, uploadImageRequest?: UploadImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(carId, setPrimary, uploadImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarImageControllerApi.uploadImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarImageControllerApi - factory interface
 * @export
 */
export const CarImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarImageControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a car image
         * @param {CarImageControllerApiDeleteImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage(requestParameters: CarImageControllerApiDeleteImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteImage(requestParameters.imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all images for a car (public endpoint)
         * @param {CarImageControllerApiGetCarImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarImages(requestParameters: CarImageControllerApiGetCarImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarImageDto>> {
            return localVarFp.getCarImages(requestParameters.carId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get car image by ID (public endpoint)
         * @param {CarImageControllerApiGetImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(requestParameters: CarImageControllerApiGetImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getImage(requestParameters.imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set an image as the primary image for a car
         * @param {CarImageControllerApiSetPrimaryImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryImage(requestParameters: CarImageControllerApiSetPrimaryImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPrimaryImage(requestParameters.imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an image for a car
         * @param {CarImageControllerApiUploadImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(requestParameters: CarImageControllerApiUploadImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImageUploadResponse> {
            return localVarFp.uploadImage(requestParameters.carId, requestParameters.setPrimary, requestParameters.uploadImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteImage operation in CarImageControllerApi.
 * @export
 * @interface CarImageControllerApiDeleteImageRequest
 */
export interface CarImageControllerApiDeleteImageRequest {
    /**
     * 
     * @type {string}
     * @memberof CarImageControllerApiDeleteImage
     */
    readonly imageId: string
}

/**
 * Request parameters for getCarImages operation in CarImageControllerApi.
 * @export
 * @interface CarImageControllerApiGetCarImagesRequest
 */
export interface CarImageControllerApiGetCarImagesRequest {
    /**
     * 
     * @type {string}
     * @memberof CarImageControllerApiGetCarImages
     */
    readonly carId: string
}

/**
 * Request parameters for getImage operation in CarImageControllerApi.
 * @export
 * @interface CarImageControllerApiGetImageRequest
 */
export interface CarImageControllerApiGetImageRequest {
    /**
     * 
     * @type {string}
     * @memberof CarImageControllerApiGetImage
     */
    readonly imageId: string
}

/**
 * Request parameters for setPrimaryImage operation in CarImageControllerApi.
 * @export
 * @interface CarImageControllerApiSetPrimaryImageRequest
 */
export interface CarImageControllerApiSetPrimaryImageRequest {
    /**
     * 
     * @type {string}
     * @memberof CarImageControllerApiSetPrimaryImage
     */
    readonly imageId: string
}

/**
 * Request parameters for uploadImage operation in CarImageControllerApi.
 * @export
 * @interface CarImageControllerApiUploadImageRequest
 */
export interface CarImageControllerApiUploadImageRequest {
    /**
     * 
     * @type {string}
     * @memberof CarImageControllerApiUploadImage
     */
    readonly carId: string

    /**
     * 
     * @type {boolean}
     * @memberof CarImageControllerApiUploadImage
     */
    readonly setPrimary?: boolean

    /**
     * 
     * @type {UploadImageRequest}
     * @memberof CarImageControllerApiUploadImage
     */
    readonly uploadImageRequest?: UploadImageRequest
}

/**
 * CarImageControllerApi - object-oriented interface
 * @export
 * @class CarImageControllerApi
 * @extends {BaseAPI}
 */
export class CarImageControllerApi extends BaseAPI {
    /**
     * 
     * @summary Delete a car image
     * @param {CarImageControllerApiDeleteImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarImageControllerApi
     */
    public deleteImage(requestParameters: CarImageControllerApiDeleteImageRequest, options?: RawAxiosRequestConfig) {
        return CarImageControllerApiFp(this.configuration).deleteImage(requestParameters.imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all images for a car (public endpoint)
     * @param {CarImageControllerApiGetCarImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarImageControllerApi
     */
    public getCarImages(requestParameters: CarImageControllerApiGetCarImagesRequest, options?: RawAxiosRequestConfig) {
        return CarImageControllerApiFp(this.configuration).getCarImages(requestParameters.carId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get car image by ID (public endpoint)
     * @param {CarImageControllerApiGetImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarImageControllerApi
     */
    public getImage(requestParameters: CarImageControllerApiGetImageRequest, options?: RawAxiosRequestConfig) {
        return CarImageControllerApiFp(this.configuration).getImage(requestParameters.imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set an image as the primary image for a car
     * @param {CarImageControllerApiSetPrimaryImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarImageControllerApi
     */
    public setPrimaryImage(requestParameters: CarImageControllerApiSetPrimaryImageRequest, options?: RawAxiosRequestConfig) {
        return CarImageControllerApiFp(this.configuration).setPrimaryImage(requestParameters.imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an image for a car
     * @param {CarImageControllerApiUploadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarImageControllerApi
     */
    public uploadImage(requestParameters: CarImageControllerApiUploadImageRequest, options?: RawAxiosRequestConfig) {
        return CarImageControllerApiFp(this.configuration).uploadImage(requestParameters.carId, requestParameters.setPrimary, requestParameters.uploadImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

